// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"347":"feed-creation-page","592":"common","833":"feed-manager-page"}[chunkId] + "." + {"347":"2736cb82d50956571b7e","592":"61a1c8494e45772dde3b","833":"23a198551ce268dd116b"}[chunkId] + ".js";
};